import { NgModule, ModuleWithProviders } from '@angular/core';
import { MonthPickerComponent } from './monthpicker.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MonthPickerMobileViewComponent } from './mobile-view/mobile-view.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  imports: [CommonModule, FormsModule, NgbModule, ScrollingModule],
  declarations: [MonthPickerComponent, MonthPickerMobileViewComponent],
  exports: [MonthPickerComponent],
})
export class DfMonthPickerModule {
  static forRoot(): ModuleWithProviders<DfMonthPickerModule> {
    return { ngModule: DfMonthPickerModule, providers: [] };
  }
}
